import React, { useEffect, useState } from "react";

import { toast } from "react-hot-toast";

import { Add_UserClient_POST, Get_UserClient_Detail_GET, Update_UserClient_PUT } from "api/ApiConst";
import { callGetApi, callPostApi, callPutApi } from "api/ApiCaller";
import { getDOB, getTimeFromDate, isAlphaNumercSpecialChar, isAlphaNumercSpecialCharSpc, isChar, isCharSpc, isEmail, isEmpty, isMobile, isNumericSpclChar, isValidIsdCode } from "utils/TextUtils";
import { MODAL_LOADER } from "utils/constants";

import ModalWrapper from "components/common/ModalWrapper";
import ImageSelector from "components/common/ImageSelector";
import Select from "react-select";

const UserClientAddEdit = ({ show, hideModal, recordID, handleRefresh, currencyOptionsList }) => {
    const defaultRecordObj ={
        firstName: "",
        lastName: "",
        gender: "",
        dateOfBirthTimeStamp: 0,
        isdCode: "+91",
        mobile: "",
        email: "",
        username: "",
        password: "",
        photoImageRefId: "",
        productIconRefId: "",
        productLogoRefId: "",
        productTitle: "",
        currencyDetail: {
          currencyId: "",
          currencyTitle: "",
          currencySubUnitTitle: "",
          unitSubdivision: 0,
          currencyCode: "",
          currencySymbol: ""
        }
      }
    const [record, setRecord] = useState(defaultRecordObj);
    const [showPassword, setShowPassword] = useState(false);
    const [selectedCurrencyOptionsList, setSelectedCurrencyOptionsList] = useState("")
   

    useEffect(() => {
        if (recordID) {
            callGetApi(MODAL_LOADER, Get_UserClient_Detail_GET.replaceAll("{recordID}", recordID), {}, (response) => {
                const res = response.responsePacket;
                res.dateOfBirthTimeStamp = getDOB(res.dateOfBirthTimeStamp);
                setRecord(res);
                setSelectedCurrencyOptionsList(currencyOptionsList.find((data) => data.value === res.currencyDetail.currencyId) )
            });
        }
    }, [recordID]);

    //Text Change Event
    const handleTextChange = (e) => {
        const { id, type, value } = e.target;
        if (id === "mobile") {
            if (value.length > 10) {
                return;
            }
        }

        if ((id === "firstName" || id === "lastName") && value.length !== 0) {
            if (!isCharSpc(value)) {
                return;
            }
        }
        if (id === "username" && value.length !== 0) {
            if (!isAlphaNumercSpecialChar(value)) {
                return;
            }
        }
        if (id === "password" && value.length !== 0) {
            if (!isAlphaNumercSpecialChar(value)) {
                return;
            }
        }
        if (id === "productTitle" && value.length !== 0) {
            if (!isAlphaNumercSpecialCharSpc(value)) {
                return;
            }
        }

        setRecord((prev) => ({ ...prev, [e.target.id]: e.target.value }));
    };

     // Option Select Event
     const handleSelect = (e) => {
        const recObj ={
            currencyId: e.currencyId,
            currencyTitle: e.currencyTitle,
            currencySubUnitTitle: e.currencySubUnitTitle,
            unitSubdivision:e.unitSubdivision,
            currencyCode:e.currencyCode,
            currencySymbol: e.currencySymbol,
          }
        setRecord({...record, currencyDetail:recObj}) ;
        setSelectedCurrencyOptionsList({
            value:e.value,
            label:e.label,
            ...e
        });
    };

    // Profile Image change
    const handleImageChange = (imageRefId) => {
        setRecord({ ...record, photoImageRefId: imageRefId });
    };

    //Product Icon Image change
    const handleProductIconChange = (imageRefId) => {
        setRecord({ ...record, productIconRefId: imageRefId });
    };
    
    //Product Icon Image change
    const handleProductLogoChange = (imageRefId) => {
        setRecord({ ...record, productLogoRefId: imageRefId });
    };

    const checkInputValidation = () => {
        if (isEmpty(record.photoImageRefId)) {
            toast.error(`Profile Image must not be empty`, { id: "toast" });
            return false;
        }
        if (isEmpty(record.productIconRefId)) {
            toast.error(`Product Icon must not be empty`, { id: "toast" });
            return false;
        }
        if (isEmpty(record.productLogoRefId)) {
            toast.error(`Product Logo image must not be empty`, { id: "toast" });
            return false;
        }
        if (isEmpty(record.firstName)) {
            toast.error(`First name must not be empty`, { id: "toast" });
            return false;
        } else if (record.firstName.length < 3) {
            toast.error(`First name must be more than 2 characters`, { id: "toast" });
            return false;
        } else if (isEmpty(record.lastName)) {
            toast.error(`Last name must not be empty`, { id: "toast" });
            return false;
        } else if (record.lastName.length < 3) {
            toast.error(`Last name must be more than 2 characters`, { id: "toast" });
            return false;
        } else if (isEmpty(record.username)) {
            toast.error(`Username must not be empty`, { id: "toast" });
            return false;
        } else if (record.username.length < 3) {
            toast.error(`User name must be more than 2 characters`, { id: "toast" });
            return false;
        }
        else if (isEmpty(record.isdCode)) {
            toast.error(`ISD Code must not be empty`, { id: "toast" });
            return false;
        } else if (!isValidIsdCode(record.isdCode)) {
            toast.error(`Please Provide Valid ISD Code`, { id: "toast" });
            return false;
        } else if (isEmpty(record.mobile)) {
            toast.error(`Mobile must not be empty`, { id: "toast" });
            return false;
        } else if (!isMobile(record.mobile)) {
            toast.error(`Please Provide Valid Mobile Number`, { id: "toast" });
            return false;
        } else if (isEmpty(record.email)) {
            toast.error(`Email must not be empty`, { id: "toast" });
            return false;
        } else if (isEmpty(record.productTitle)) {
            toast.error(`Product Title must not be empty`, { id: "toast" });
            return false;
        } else if (record.productTitle.length < 3) {
            toast.error(`Product Title must be more than 3 characters`, { id: "toast" });
            return false;
        } else if (isEmpty(record.dateOfBirthTimeStamp)) {
            toast.error(`Date Of Birth must not be empty`, { id: "toast" });
            return false;
        }
        if (isEmpty(record.currencyDetail.currencyId)) {
            toast.error(`Currency must not be empty`,{id: "toast"});
            return false;
        }
        else if (!recordID) {
            if (isEmpty(record.password)) {
                toast.error(`Password must not be empty`, { id: "toast" });
                return false;
            }
            else if (record.password.length < 7) {
                toast.error(`Password must  be more than 6 characters`, { id: "toast" });
                return false;
            }
        }
        if (record.dateOfBirthTimeStamp) {
            var currentDate = new Date();
            var dobDate = new Date(record.dateOfBirthTimeStamp);
            if (dobDate.getTime() > currentDate.getTime()) {
                toast.error(`Please Provide Valid date Of Birth`, { id: "toast" });
                return false;
            }
        }

        return true;
    };

    //Submit Avatar Form
    const handleSubmit = async () => {

        const recObj ={
            currencyId: selectedCurrencyOptionsList.currencyId,
            currencyTitle: selectedCurrencyOptionsList.currencyTitle,
            currencySubUnitTitle: selectedCurrencyOptionsList.currencySubUnitTitle,
            unitSubdivision:selectedCurrencyOptionsList.unitSubdivision,
            currencyCode:selectedCurrencyOptionsList.currencyCode,
            currencySymbol: selectedCurrencyOptionsList.currencySymbol,
          }

        try {
            if (!checkInputValidation()) {
                return;
            }
            let recordObj = record;
            recordObj.dateOfBirthTimeStamp = getTimeFromDate(recordObj.dateOfBirthTimeStamp);
            recordObj.currencyDetail = recObj;
            if (!recordID || recordID === "") {
                callPostApi(MODAL_LOADER, Add_UserClient_POST, recordObj, {}, (response) => {
                    toast.success(response.message, {id: "toast"});
                    hideModal();
                    handleRefresh();
                });
            } else {
                callPutApi(MODAL_LOADER, Update_UserClient_PUT.replaceAll("{recordID}", recordID), recordObj, {}, (response) => {
                    toast.success(response.message, {id: "toast"});
                    hideModal();
                    handleRefresh();
                });
            }
        } catch (error) {
            return;
        }
    };

    return (
        <ModalWrapper show={show} hide={hideModal} backdrop="static" header={`${recordID ? "Update" : "Add"} User Client`} handleSubmit={handleSubmit}>
            <div className="form-group row mb-3">
                <div className="col-lg-4">
                    <label>Profile Image</label>
                    <ImageSelector
                        style={{
                            height: "120px",
                            width: "120px",
                            borderRadius: "50%",
                            overflow: "hidden",
                        }}
                        user={true}
                        handleImageChange={handleImageChange}
                        selectedImage={record.photoImageRefId}
                    />
                </div>
                <div className="col-lg-4">
                    <label>Product Icon</label>
                    <ImageSelector
                        style={{
                            height: "120px",
                            width: "120px",
                            // borderRadius: "50%",
                            overflow: "hidden",
                        }}
                        handleImageChange={handleProductIconChange}
                        selectedImage={record.productIconRefId}
                    />
                </div>
                <div className="col-lg-4">
                    <label>Product Logo</label>
                    <ImageSelector
                        style={{
                            height: "120px",
                            width: "120px",
                            // borderRadius: "50%",
                            overflow: "hidden",
                        }}
                        handleImageChange={handleProductLogoChange}
                        selectedImage={record.productLogoRefId}
                        />
                </div>
             </div>
            <div className="form-group row mb-3">
                <div className="col-lg-6">
                    <label>First Name *</label>
                    <input type="text" maxLength={16} className="form-control input-default" id="firstName" onChange={handleTextChange} value={record.firstName} />
                </div>
                <div className="col-lg-6">
                    <label>Last Name *</label>
                    <input type="text" maxLength={16} className="form-control input-default" id="lastName" onChange={handleTextChange} value={record.lastName} />
                </div>
            </div>
            {!recordID && (
                <div className="form-group row mb-3">
                    <div className="col-lg-6">
                        <label>Username *</label>
                        <input type="username" maxLength={25} className="form-control input-default" id="username" onChange={handleTextChange} value={record.username} />
                    </div>
                    <div className="col-lg-6">
                        <label>Password *</label>
                        <div className="input-group auth-pass-inputgroup">
                            <input type={showPassword ? "text" : "password"} maxLength={16} className="form-control input-default" id="password" onChange={handleTextChange} value={record.password} />
                            <button className="btn btn-light " type="button" id="password-addon" onClick={() => setShowPassword(!showPassword)}>
                                {showPassword ? <i className="mdi mdi-eye-off-outline" /> : <i className="mdi mdi-eye-outline" />}
                            </button>
                        </div>
                    </div>
                </div>
            )}
            <div className="form-group row mb-3">
                <div className="col-lg-6">
                    <div className="row g-1">
                        <div className="col-4">
                            <label>ISD Code *</label>
                            <input type="text" className="form-control input-default" id="isdCode" onChange={handleTextChange} value={record.isdCode} />
                        </div>
                        <div className="col-8">
                            <label>Mobile *</label>
                            <input type="number" className="form-control input-default" id="mobile" onChange={handleTextChange} value={record.mobile} />
                        </div>
                    </div>
                </div>
                <div className="col-lg-6">
                    <label>Email *</label>
                    <input type="email" className="form-control input-default" id="email" onChange={handleTextChange} value={record.email} />
                </div>
            </div>
            <div className="form-group mb-3 row">
                <div className="col-lg-3">
                    <label className="d-block">Gender</label>
                    <div className="form-check form-check-inline">
                        <input
                            className="form-check-input"
                            type="radio"
                            name="gender"
                            id="male"
                            defaultValue="male"
                            checked={record.gender?.toLowerCase() === "male"}
                            onChange={(e) => setRecord({ ...record, gender: "Male" })}
                        />
                        <label className="form-check-label" htmlFor="male">
                            Male
                        </label>
                    </div>
                    <div className="form-check form-check-inline">
                        <input
                            className="form-check-input"
                            type="radio"
                            name="gender"
                            id="female"
                            defaultValue="female"
                            checked={record.gender?.toLowerCase() === "female"}
                            onChange={(e) => setRecord({ ...record, gender: "Female" })}
                        />
                        <label className="form-check-label" htmlFor="female">
                            Female
                        </label>
                    </div>
                </div>
                <div className="col-lg-5">
                    <label>Product Title *</label>
                    <input type="text" maxLength={20} className="form-control input-default" id="productTitle" onChange={handleTextChange} value={record.productTitle} />
                </div>
                <div className="col-lg-4">
                    <label>Date Of Birth *</label>
                    <input className="form-control" type="date" id="dateOfBirthTimeStamp" value={record.dateOfBirthTimeStamp} onChange={handleTextChange} />
                </div>
            </div>
            <div className="form-group mb-3 row">
                <div className="col-lg-4">
                    <label>Currency selector</label>
                    <Select options={currencyOptionsList} onChange={(e)=>handleSelect(e)} value={selectedCurrencyOptionsList} />


                </div>
            </div>
        </ModalWrapper>
    );
};

export default UserClientAddEdit;
